import { styled } from '@linaria/react';

export const MessagesSwitchContainer = styled.div`
	display: flex;
	min-width: 6.4rem;
	align-items: center;
	justify-content: space-between;
	font-size: var(--font-size-m);
	font-weight: var(--font-weight-semibold);
	line-height: 100%;
`;

export const MessagesSwitchButton = styled.button`
	display: flex;
	align-items: center;
	padding: 0.2rem;
	border: none;
	background: none;
	cursor: pointer;

	& svg {
		width: 1.4rem;
		height: 1.4rem;
	}

	&:disabled {
		color: var(--color-white-m);
	}

	&[name='right'] svg {
		transform: rotate(180deg);
	}
`;
